import { render, staticRenderFns } from "./CompletedTA7.vue?vue&type=template&id=c9df04f8&scoped=true&"
import script from "./CompletedTA7.vue?vue&type=script&lang=js&"
export * from "./CompletedTA7.vue?vue&type=script&lang=js&"
import style0 from "./CompletedTA7.vue?vue&type=style&index=0&id=c9df04f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9df04f8",
  null
  
)

export default component.exports